export const listTef = [
  { textCredential: 'Datafast PinPad', valueCredential: '1' },
  { textCredential: 'Medianet PinPad', valueCredential: '2' },
]
